import { View, Text } from "react-native";
import MapPinIcon from "../../svgs/MapPinIcon";
import { EventDetailsQuery } from "./types";

interface LocationSectionProps {
  event: EventDetailsQuery["event"];
}

export default function LocationSection({ event }: LocationSectionProps) {
  const { facility, address1, address2, city, state, zip, location } = event;

  return (
    <>
      <MapPinIcon height={22} width={22} testID="map-pin-icon" />
      <View className="flex-1 min-w-0 pl-2">
        <Text className="text-small-normal font-700 text-ink-darker">Location</Text>
        <View className="flex-col flex-wrap">
          {facility && <Text className="text-small-normal text-ink-darker font-400">{facility?.name}</Text>}
          {address1 && <Text className="text-small-normal text-ink-darker font-400">{address1}</Text>}
          {address2 && <Text className="text-small-normal text-ink-darker font-400">{address2}</Text>}
          {city && state && zip && (
            <Text className="text-small-normal text-ink-darker font-400">{`${city}, ${state} ${zip}`}</Text>
          )}
          {location && (
            <View className="pt-3">
              <Text className="text-small-normal font-700 text-ink-darker">Location Details</Text>
              <Text className="text-small-normal text-ink-darker font-400">{location}</Text>
            </View>
          )}
        </View>
      </View>
    </>
  );
}
